//@todo - move to commom place

!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (window.define)
		define('common/currencyConverter',['vendor/mustache', 'libs/ct_view', 'libs/ct_store', 'ct_utils'], module)
	else
	
	//>>excludeEnd("requireTmpl");
		context[name] = module(Mustache, CT.View, CT.Store)

}('currencyConverter', function(Mustache, View, store) {

	var currencyConverter = {
			
		events : {
			"click .currencyMenu li a" : "changeCurrency",
			"click .currencyLink" : 'showCurrencyList',
			"click .countryLink" : 'showCountryList',
			"click .countryMenu li a" : 'redirectCountryUrl',
			"click .languageLink" : 'showLanguageList',
			"click .languageMenu li a" : "changeLang"
		},
		
		redirectCountryUrl : function(evt) { 
			var $target =  evt.target.nodeName.toLowerCase() === 'a' ? $(evt.target) : $(evt.target).parents("a");
			
			var val = $target.attr("ctValue"),
				url = $target.attr("ctUrl");
			window.location.href = url + "/?c=" + val.toLowerCase();
		},
		
		showCurrencyList :  function() {
			$currencyLink = this.$el.find(".currencyLink");
			$currencyMenu = this.$el.find(".currencyMenu");
			$currencyMenu.toggle();
			$currencyLink[( ($currencyMenu.get(0).style.display != "none")? "add" : "remove" ) + "Class"]("current");
		},
		
		
		showCountryList : function() {
			$countryLink = this.$el.find(".countryLink");
			$countryMenu = this.$el.find(".countryMenu");
			$countryMenu.toggle();
			$countryLink[( ($countryMenu.get(0).style.display != "none")? "add" : "remove" ) + "Class"]("current");
		},
		showLanguageList : function (){
			$langLink = this.$el.find(".languageLink");
			$langMenu = this.$el.find(".languageMenu");
			$langMenu.toggle();
			$langLink[( ($langMenu.get(0).style.display != "none")? "add" : "remove" ) + "Class"]("current");
			if(CT.utils.genericBlocks && CT.utils.genericBlocks.hideLanguagePrefToolTip){
	    		CT.utils.genericBlocks.hideLanguagePrefToolTip();
	    	}
		},
		
		
		changeLang : function (e){
			var ele = $(e.target), _attr = ele.attr('data-lang');
			
			if(_attr === "Arabic"){
				CT.utils.cookies.create('lp', 'ar', 365);
				window.location.href='/ar/';
			}else{
				CT.utils.cookies.create('lp', 'en', 365);
				window.location.href='/';
			}
			
			
			
			
			if(CT.app === 'air') {	
				CT.utils.helperFunctions.trackGAEvent('Home_TS','click','language_selection','100');
			}
		},
		
		
		changeCurrency : function (e){
			var ele = (e.target.tagName.toLowerCase() === "span" ) ? $(e.target).parents("a") : $(e.target)
			, s = { code : ele.attr('data-currency'), symbol : ele.attr('data-currency-symbol') }
			, $currentTab = $('#ResultContainer_' + CT.settings.currentTab)
			, mJson = CT.masterJson ? CT.masterJson.get() : undefined;
			
			var  currSybStr = "";
			
			var $currencyUl = this.$el.find(".currencyMenu"); 
			var $liElem = $currencyUl.find("li");
			$liElem.removeClass("current");
			$liElem.find("i.tickMark").remove();
			
			
			ele.parent().addClass('current')
			if(s.code !== s.symbol) {
				currSybStr = "<span class='"+s.code+"'>&nbsp;"+s.symbol+"</span>";
			}
			
			this.$el.find('a.currencyLink').html("<strong>Currency</strong>&nbsp;&nbsp;"+s.code+""+currSybStr);
			var $currencyLi = $currencyUl.find("span."+ s.code).closest("li");
			$currencyLi.addClass("current").find("a").prepend("<i class='tickMark black'></i>");

			CT.settings.countryCurrCode['current'] = s.code
			
			
			if(CT.app == 'hotel'){//trigger the render functions
				CT.utils.setCurrency(s);//changing disp_currency values
				mJson ? $currentTab.trigger('changeCurrency.trigger') : (window.triggerChangeCurrency && triggerChangeCurrency());
			} else if(CT.app == "shortlist"){
				CT.utils.setCurrency(s);//changing disp_currency values
				CT.fire('updateHotelObject');
			}
			else if (CT.app == 'dp'){
				CT.utils.setCurrency(s);//changing disp_currency values
				CT.utils.cookies.create('dpCurr',s.code,1);
				CT.fire('filters_apply');
			}
				
			else{ //trigger the filter functions
				CT.utils.setCurrency(s);//changing disp_currency values
				if(mJson) {
					$(CT.settings.selectors.filters)
					.trigger('filters_update',[mJson, null, {preset: true}])
					.trigger('filters_apply',[{onload: true}])//changing filters.apply and filter.update custom events to underscore events..because IE its not working
					if(mJson.jsons.searchType.roundTrip && (!mJson.jsons.searchType.isIntl || (mJson.jsons.searchType.isIntl && mJson.jsons.searchType.intlSpecialRT)) && !mJson.jsons.searchType.multiCity) {
						$currentTab.trigger('changeCurrency.trigger',[mJson]);
					}
					$currentTab.find(".miniCalendar").hide();
					if(!mJson.jsons.searchType.isMeta && !mJson.jsons.searchType.multiCity){
						CT.fire('calendar.init');
					}
				}
			}
			
			store('Curr').update(s)
		},
		
		// render the currency picker in footer for air and hotels
		render : function() {
			var _elem = [], _curr = _.extend({}, window.currencies);
			var html="";
			
			var compare = function (a,b) {
				if (a.name < b.name)
					return -1;
				if (a.name > name)
					return 1;
				  return 0;
			}
			
			var $currMenuObj = this.$el.find(".currencyMenu");
			if(_curr !== undefined && ($currMenuObj && $currMenuObj.length >0) ){
				/*_.forEach(_curr.top,function (val, idx){
					var sym = unescape(val.symbol.replace('\\', '%'))
					_elem.push({"code":val.code,"text": val.name,'symbol' : sym, 'currencyCls': (idx == _curr.top.length-1) ? 'separator' : ''});
				})
				
				*/
				_curr.all = _.filter(_curr.all, function(curr) { return _.contains(CT.settings.currencyArr, curr.name) }).sort(compare);
				
				_.forEach(_curr.all,function (val){
					var sym = unescape(val.symbol.replace('\\', '%'))
					_elem.push({"code":val.code,"text": val.name, 'symbol' : sym, 'currencyCls': ''});
				})
				
				var limit = Math.ceil(_elem.length/2);
		
				var chunk  = [];
				chunk.push(_elem.slice(0,limit));
				chunk.push(_elem.slice(limit,_elem.length));
				_.each(chunk, function(arr, idx) {
					html += "<ul class='currencyCol'>";
					html += CT.to_html('CurrencyConverterTpl', {'currencyMenu' : arr, 'cls':'listMenu'});
					html += "</ul>";
				});
						
				$currMenuObj.html(html);
			}else setTimeout(function (){currencyConverter.render()},1000);

			CT.utils.showActiveCurrMenu();
		}

	}
	
	CT.subscribe('init.ccr', function(prObj, callback) {
		if(!window.disp_currency){
			window.disp_currency = {code : "", symbol : ""}
		}
		currencyConverter.$el =  $(".ctGlobalNav");
		var _ccr = View(currencyConverter);
		var baseLink = window.hotelBaseLink || window.airBaseLink || window.staticBaseLink || "";
		//dynamically loading the currency.js file.
		var ccrDate = new Date();
		var ccrTimestamp = ccrDate.getFullYear()+''+ccrDate.getMonth()+''+ccrDate.getDate()+''+ccrDate.getHours();
		CT.getScript({src : baseLink+'/json/currency.js?ts='+ccrTimestamp}, function(){
			_ccr.render();
			if(callback && typeof callback == 'function'){
				callback();
			}
		});
		
		//default selection of language picker
		//var lang = (CT.utils.cookies.read('lang-pref') === 'ar')  ? "Arabic" : "English";
		var displayLangMapper={"Arabic":"English" , "English":"&#1593;&#1585;&#1576;&#1610;"}
		var lang = (window.CT.langUrlPrefix === '/ar')  ? "Arabic" : "English";
		var displayLang = displayLangMapper[lang];
		var $langLinkEl = currencyConverter.$el.find('.languageLink');
		$langLinkEl.html(displayLang)
			.attr("data-lang", lang)
			.show();
		
	});
	
	return currencyConverter;
}, CT.settings);

